var _excluded = ["children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types"; // < href="#" onClick> is not accessible but our <button>
// has a ton of CSS on it, so if you have to use an <a> with an onClick
// then at least use this one

var LinkButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("a", _extends({
    style: {
      cursor: rest.disabled ? "not-allowed" : "pointer"
    },
    role: "button",
    "aria-label": rest["aria-label"] || rest.title,
    tabIndex: rest.disabled ? undefined : 0,
    ref: ref,
    onKeyDown: function onKeyDown(event) {
      if (event.key === "Enter" && typeof rest.onClick === "function") {
        rest.onClick(event);
      }
    }
  }, rest), children);
});
LinkButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.number, PropTypes.array]),
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
LinkButton.defaultProps = {
  children: function children() {
    return null;
  }
};
export default LinkButton;